/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  trackListItemImpressionEvent
 */

import { getUser } from '@zcode-ui/web-zumper-global-state'
import { LIST_ITEM_IMPRESSION, event, getTraktorEntityId } from '@zcode-ui/web-zumper-integrations'
import { getCurrentLocation, getCurrentSearchListables } from '../../../inspectors/index'
import { selectFilters } from '../../filters/selectors/index'

export const trackListItemImpressionEvent =
  ({
    listName,
    pageNumber,
    visibleFilterAdIndices,
    visiblePropertyIds,
    visiblePropertyIndicies,
    visibleTopPickPropertyIds,
  }) =>
  (dispatch, getState) => {
    const state = getState()
    const user = getUser(state)
    const filters = selectFilters(state)
    const location = getCurrentLocation(state)
    const listables = getCurrentSearchListables(state)
    const pageItemsCount = listables?.length
    const loadedPropertyIds = listables.map((el) => getTraktorEntityId(el))

    const props = {
      listName,
      loadedPropertyIds,
      pageItemsCount,
      pageNumber,
      visibleFilterAdIndices,
      visiblePropertyIds,
      visiblePropertyIndicies,
      visibleTopPickPropertyIds,
    }

    dispatch(event({ name: LIST_ITEM_IMPRESSION, props, user, filters, location }))
  }
